/**
 * @typedef {object} StoreRedirectInfo
 * @property {string} country     - Country segment for the URL prefix (e.g. "es", "uk", "ae")
 * @property {string} slug        - New URL slug (already URL-encoded if needed)
 * @property {Record<string, string>} langMap - Maps locale prefix (e.g. "es", "en", "nl")
 *           to the language segment used in the new URL
 * @property {string} defaultLang - Fallback language segment when no match is found
 */

/**
 * Maps each store ID to the new stores-locator URL info.
 * @type {Record<string, StoreRedirectInfo>}
 */
export const LEGACY_REDIRECT_MAP = {
  14766: {
    country: 'es',
    slug: 'zara-madrid-plaza-espa%C3%B1a-s14766',
    langMap: { es: 'es', gl: 'es', eu: 'es', ca: 'es', en: 'en' },
    defaultLang: 'es',
  },
  3714: {
    country: 'nl',
    slug: 'zara-den-haag-spuimarkt-s3714',
    langMap: { nl: 'nl', en: 'en' },
    defaultLang: 'en',
  },
  301: {
    country: 'pt',
    slug: 'zara-porto-santa-catarina-s301',
    langMap: { pt: 'pt', en: 'en' },
    defaultLang: 'en',
  },
  3327: {
    country: 'it',
    slug: 'zara-milano-buenos-aires-s3327',
    langMap: { it: 'it', en: 'en' },
    defaultLang: 'en',
  },
  14512: {
    country: 'uk',
    slug: 'zara-london-battersea-s14512',
    langMap: { en: 'en' },
    defaultLang: 'en',
  },
  12477: {
    country: 'es',
    slug: 'zara-valencia-juan-de-austria-s12477',
    langMap: { es: 'es', gl: 'es', eu: 'es', ca: 'es', en: 'en' },
    defaultLang: 'es',
  },
  14914: {
    country: 'fr',
    slug: 'zara-paris-avenue-des-champs-elysees-74-s14914',
    langMap: { fr: 'fr', en: 'en' },
    defaultLang: 'en',
  },
  6460: {
    country: 'es',
    slug: 'zara-santiago-de-compostela-s6460',
    langMap: { es: 'es', gl: 'es', eu: 'es', ca: 'es', en: 'en' },
    defaultLang: 'es',
  },
  6437: {
    country: 'it',
    slug: 'zara-arese-shopping-center-s6437',
    langMap: { it: 'it', en: 'en' },
    defaultLang: 'en',
  },
  3197: {
    country: 'it',
    slug: 'zara-milano-vittorio-emmanuele-s3197',
    langMap: { it: 'it', en: 'en' },
    defaultLang: 'en',
  },
  3488: {
    country: 'ae',
    slug: 'zara-dubai-mall-of-the-emirates-s3488',
    langMap: { ar: 'ar', en: 'en' },
    defaultLang: 'en',
  },
  14965: {
    country: 'nl',
    slug: 'zara-rotterdam-s14965',
    langMap: { nl: 'nl', en: 'en' },
    defaultLang: 'en',
  },
  16231: {
    country: 'es',
    slug: 'zara-sevilla-duque-s16231',
    langMap: { es: 'es', gl: 'es', eu: 'es', ca: 'es', en: 'en' },
    defaultLang: 'es',
  },
};
